import './splash.css';
import splashArt from '../assets/splash-art.jpg';

/**
 * Indítóképernyő a saját artworkkel: teljes kép (a széleken elmosott
 * háttérrel), alul a START gomb és a játék alcíme. Csak kattintásra vagy
 * billentyűre tűnik el – automatikus továbblépés nincs.
 */
export function showSplash(root: HTMLElement): Promise<void> {
  const el = document.createElement('div');
  el.className = 'splash';
  el.setAttribute('role', 'presentation');

  const backdrop = document.createElement('div');
  backdrop.className = 'splash__backdrop';
  backdrop.style.backgroundImage = `url("${splashArt}")`;
  backdrop.setAttribute('aria-hidden', 'true');

  const art = document.createElement('img');
  art.className = 'splash__art';
  art.src = splashArt;
  art.alt = '';
  art.decoding = 'async';
  art.draggable = false;
  art.setAttribute('aria-hidden', 'true');
  art.setAttribute('fetchpriority', 'high');

  const inner = document.createElement('div');
  inner.className = 'splash__inner';

  const kicker = document.createElement('div');
  kicker.className = 'splash__kicker';
  kicker.textContent = 'CSÚCSFORGALOM KUPA';

  const sub = document.createElement('div');
  sub.className = 'splash__sub';
  sub.textContent = 'VÁROSI KART VERSENY · 1–4 JÁTÉKOS';

  const press = document.createElement('div');
  press.className = 'splash__press';
  press.textContent = 'START';

  const hint = document.createElement('div');
  hint.className = 'splash__hint';
  hint.textContent = 'KATTINTS VAGY NYOMJ EGY GOMBOT';

  const foot = document.createElement('div');
  foot.className = 'splash__foot';
  foot.textContent = '© 2026 · BILLENTYŰZET / GAMEPAD';

  inner.append(kicker, sub, press, hint, foot);

  const scan = document.createElement('div');
  scan.className = 'splash__scan';
  scan.setAttribute('aria-hidden', 'true');

  el.append(backdrop, art, inner, scan);
  root.appendChild(el);

  return new Promise((resolve) => {
    let done = false;
    let armed = false;
    const armTimer = window.setTimeout(() => {
      armed = true;
      press.classList.add('is-ready');
    }, 650);

    const cleanup = (): void => {
      window.removeEventListener('keydown', onKey, true);
      window.removeEventListener('pointerdown', onPointer, true);
      window.clearTimeout(armTimer);
    };

    const finish = (): void => {
      if (done) return;
      done = true;
      cleanup();
      el.classList.add('splash--out');
      window.setTimeout(() => {
        el.remove();
        resolve();
      }, 380);
    };

    const onKey = (event: KeyboardEvent): void => {
      if (!armed) return;
      event.preventDefault();
      event.stopPropagation();
      finish();
    };

    const onPointer = (event: PointerEvent): void => {
      if (!armed) return;
      event.preventDefault();
      event.stopPropagation();
      finish();
    };

    window.addEventListener('keydown', onKey, true);
    window.addEventListener('pointerdown', onPointer, true);
  });
}
